import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import HomeScreen from 'components/NextconLabHome/HomeScreen';


function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar />
        <HomeScreen />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <HomeScreen />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;
